import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import styles from './MultipleModal.module.scss';

export const MultipleModal = ({
  visible,
  onVisible,
  onClose,
  children,
  destroyOnClose = true,
}) => {
  const [shouldRender, setShouldRender] = useState(visible);
  const [mouseDownInside, setMouseDownInside] = useState(false);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflowY = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      document.body.style.overflowY = 'auto';
      document.body.style.paddingRight = '';
      if (destroyOnClose) {
        const timeout = setTimeout(() => setShouldRender(false), 0);
        return () => clearTimeout(timeout);
      }
    }
  }, [visible, destroyOnClose]);

  const handleMouseDown = (e) => {
    if (bodyRef.current && bodyRef.current.contains(e.target)) {
      setMouseDownInside(true);
    } else {
      setMouseDownInside(false);
    }
  };

  const handleClick = () => {
    if (!mouseDownInside) onClose();
  };

  if (!shouldRender && destroyOnClose) return null;

  return (
    <div
      className={cn(styles.root, { [styles.root_visible]: visible })}
      onMouseDown={handleMouseDown}
      onClick={handleClick}
    >
      <div
        ref={bodyRef}
        className={styles.body}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};
